import React from 'react'
import { array, bool, number } from 'prop-types'

import SummaryLabel from './Components/SummaryLabel'
import TrendingLabel from './TrendingLabel'
import { levelNames } from '../../../constants'

const formatTags = (tags) => {
  return tags.reduce((acc, tag) => {
    const level = tag.complexity || 1
    if (!acc[level]) {
      acc[level] = []
    }
    acc[level].push(tag)
    return acc
  }, {})
}

function SummaryTable({
  tagsLoading,
  tagsWithoutPenalty,
  tagsWithPenalty,
  hasAnyTagsWithPenalty,
  limitTagCampaignsAndCostInflation,
  totalCostPerDay,
}) {
  const selectedTagsWithoutPenaltyByLevel = formatTags(tagsWithoutPenalty)
  const selectedTagsWithPenaltyByLevel = formatTags(tagsWithPenalty)

  return (
    <div className="promote-modal__summary-section">
      <SummaryLabel
        numberOfTags={tagsWithoutPenalty.length}
        hasAnyTagsWithPenalty={hasAnyTagsWithPenalty}
        limitTagCampaignsAndCostInflation={limitTagCampaignsAndCostInflation}
      />
      {tagsWithoutPenalty.length > 0 && (
        <div className="promote-modal__summary-breakdown">
          {Object.entries(selectedTagsWithoutPenaltyByLevel)
            .sort(([a], [b]) => parseInt(b, 10) - parseInt(a, 10)) // Sort by level descending
            .map(([level, levelTags]) => {
              const levelCost = levelTags.length * parseInt(level, 10)
              return (
                <div key={level} className="promote-modal__summary-row">
                  <span className="promote-modal__left-column">{levelNames[level]}</span>
                  <span className="promote-modal__center-column">
                    {levelTags.length} tags x {level} credits
                  </span>
                  <span className="promote-modal__right-column">
                    {levelCost} credit{levelCost !== 1 ? 's' : ''}
                  </span>
                </div>
              )
            })}
        </div>
      )}
      {limitTagCampaignsAndCostInflation && tagsWithPenalty.length > 0 && (
        <>
          <TrendingLabel numberOfTagsWithoutPenalty={tagsWithoutPenalty.length} />
          <div className="promote-modal__summary-breakdown">
            {Object.entries(selectedTagsWithPenaltyByLevel)
              .sort(([a], [b]) => parseInt(b, 10) - parseInt(a, 10)) // Sort by level descending
              .map(([level, levelTags]) => levelTags.map(tag => {
                const tagCost = (tag.complexity || 1) + (tag.penalty || 0)

                return (
                  <div key={level} className="promote-modal__summary-row">
                    <span className="promote-modal__left-column">{tag.tag}</span>
                    <span className="promote-modal__center-column">
                      {levelNames[level]}
                    </span>
                    <span className="promote-modal__right-column">
                      {tagCost} credit{tagCost !== 1 ? 's' : ''}
                    </span>
                  </div>
                )
              }))}
          </div>
        </>
      )}
      <div className="promote-modal__summary-divider" />
      <div className="promote-modal__summary-row">
        <span className="promote-modal__summary-key">Total tags cost (per day)</span>
        {!tagsLoading && (
          <span className="promote-modal__summary-value">
            {totalCostPerDay} credit{totalCostPerDay !== 1 ? 's' : ''}
          </span>
        )}
      </div>
    </div>
  )
}

SummaryTable.propTypes = {
  tagsLoading: bool.isRequired,
  tagsWithoutPenalty: array.isRequired,
  tagsWithPenalty: array.isRequired,
  hasAnyTagsWithPenalty: bool.isRequired,
  limitTagCampaignsAndCostInflation: bool.isRequired,
  totalCostPerDay: number.isRequired,
}

export default SummaryTable
